// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.batch-fetch-title-k8IwT9{margin-bottom:16px;font-size:14px;font-weight:400;line-height:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"batch-fetch-title": `batch-fetch-title-k8IwT9`,
	"batchFetchTitle": `batch-fetch-title-k8IwT9`
};
export default ___CSS_LOADER_EXPORT___;
